import React, { useState, createContext } from "react";

export const RegisterProviderContext = createContext()

export const RegisterProvider = (props) => {
    const [formStep1Values, setFormStep1Values] = useState();
    const [formStep2Values, setFormStep2Values] = useState();

    return (
        <RegisterProviderContext.Provider
        value={{
            formStep1Values, 
            setFormStep1Values,

            formStep2Values,
            setFormStep2Values,
        }}
        >
            {props.children}
        </RegisterProviderContext.Provider>
    )
}